import React, { FC } from 'react';
import { Avatar } from 'components/atoms/avatar';
import { fullName } from 'utils/full-name';
import { CellRendererParams } from './types';

export const AvatarRenderer: FC<CellRendererParams> = ({ data }) => {
  const name = fullName(data);

  return (
    <Avatar
      name={name === '' ? data.emailId : name}
      src={data.photoUrl}
      size="large"
    />
  );
};
